const dictionaryParser = ({ content, variables }: {content: string, variables: Array<object>}) => {
  variables.forEach(variable => {
    const data = Object.entries(variable)[0];
    content = content?.replaceAll(`:${data[0]}`, data[1]);
  });
  return content;
};

export default dictionaryParser;
